var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":9}},[_c('el-container',{staticClass:"card"},[_c('router-link',{staticClass:"card-link",attrs:{"to":{ name: `${_vm.path}` },"tag":"span"}},[_vm._v("\n      "+_vm._s(_vm.cardMessage)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }